import * as React from "react";

import { CoreDetailProps } from "../Detail";

export class CoreDetailsButtons extends React.Component<CoreDetailProps> {
    public render() {
        return (<div />);
    }
}
